import { selectLanguage, setLanguage, useAppDispatch } from "@org-avp/avp-avengers-ui-shared-store";
import { Select, SelectProps } from "antd";
import { useCallback, useMemo } from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";

export const LanguageSelect = () => {
  const dispatch = useAppDispatch();
  const language = useSelector(selectLanguage);
  const changeLanguage = useCallback((language: string) => dispatch(setLanguage(language)), [dispatch]);

  const languageSelectOptions: SelectProps["options"] = useMemo(
    () => language.availableLanguages.map((lang) => ({
      label: <Trans ns="common" i18nKey={`languageSelector.languageName.${lang}`}/>,
      value: lang,
    })),
    [language.availableLanguages],
  );

  return (
    <Select
      value={language.selectedLanguage}
      onChange={(value) => changeLanguage(value)}
      options={languageSelectOptions}
    />
  );
};
